import { FC } from "react";
import { Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import PageRoute from "routes/PageRoute";

import { AutomationsRoutes } from "../constants";

import Macro from "./Macro";
import { MacrosList } from "./MacrosList";

const Macros: FC<IWithBreakpointsProps> = ({ isMobile }) => (
  <Switch>
    {!isMobile && (
      <PageRoute path={AutomationsRoutes.AddMacro} documentTitle="New macro" exact>
        <Macro mode="add" />
      </PageRoute>
    )}
    {!isMobile && (
      <PageRoute path={`${AutomationsRoutes.AddMacro}/:macroId`} documentTitle="New macro" exact>
        <Macro mode="add" />
      </PageRoute>
    )}
    {!isMobile && (
      <PageRoute path={`${AutomationsRoutes.EditMacro}/:macroId`} documentTitle="Edit macro" exact>
        <Macro mode="edit" />
      </PageRoute>
    )}
    {!isMobile && <PageRoute exact path={AutomationsRoutes.Macros} component={MacrosList} documentTitle="Macros" />}
    <Redirect to={AutomationsRoutes.Macros} />
  </Switch>
);
export default withBreakpoints(Macros);
